var counter = 1;

function uniqueId() {
  return counter++;
}

export default uniqueId;